<template>
    <div>
        <el-dialog
            top="0px"
            :title="dialogTitle"
            :visible="dialogVisible"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            width="900px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            custom-class="c-dialog"
            @close="handleClose"
            :show-close="false"
            modal-append-to-body
        >
            <!-- <div class="h-tip">{{ tip }}</div> -->
            <div class="dialog-main">
                <div class="form-container">
                    <el-form
                        ref="form"
                        :model="formData"
                        :rules="rules"
                        label-width="110px"
                        style="display: inline-block"
                    >
                        <el-form-item label="标注任务名称" prop="name">
                            <el-input style="width: 300px" clearable v-model="formData.name" :placeholder="placeholderTaskName"></el-input>
                        </el-form-item>
                        <el-form-item label="数据类型">
                            <el-radio-group v-model="formData.dataType">
                                <el-radio :label="2">照片</el-radio>
                                <el-radio :label="1">视频</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="导入方式">
                            <el-radio-group v-model="formData.sourceType">
                                <el-radio :label="SourceTypeEmu.REMOTE">原始数据</el-radio>
                                <el-radio :label="SourceTypeEmu.ACHIEVEMENT">结果数据</el-radio>
                                <el-radio :label="SourceTypeEmu.COMPUTER">本地导入</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            label="选择文件"
                            v-if="formData.sourceType == 'computer'"
                            prop="fileList"
                        >
                            <el-upload
                                class="upload-demo"
                                drag
                                action="#"
                                multiple
                                :accept="accept"
                                :before-upload="beforeUpload"
                                :http-request="handleUpload"
                                :on-remove="handleRemove"
                            >
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <!-- <div class="next-container" v-if="formData.sourceType === SourceTypeEmu.COMPUTER" style="text-align: center">
                    <el-button @click="doNext" type="primary" :disabled="disabled">{{
                       '确定'
                    }}</el-button>
                </div> -->
            </div>
            <div class="dialog-main" v-if="formData.sourceType !== SourceTypeEmu.COMPUTER">
                <div class="search-container">
                    <el-form :model="searchForm" inline label-width="80px">
                        <el-form-item :label="labelName">
                            <el-input
                                size="small"
                                v-model="searchForm.name"
                                :placeholder="`请输入${labelName}`"
                                style="width: 150px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="任务名称">
                            <el-input
                                v-model="searchForm.taskName"
                                placeholder="请输入任务名称"
                                style="width: 150px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="上传时间">
                            <el-date-picker
                                placeholder="请选择上传时间"
                                style="width: 152px"
                                v-model="searchForm.timeStart"
                                value-format="yyyy-MM-dd"
                                @change="handleDatePickerChange"
                            ></el-date-picker>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="doSearch">搜索</el-button>
                            <el-button type="primary" plain @click="reset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div>
                    <el-table
                        :data="tableData"
                        border
                        size="mini"
                        @selection-change="handleSelectionChange"
                        stripe
                        height="300px"
                    >
                        <el-table-column type="selection" width="55"> </el-table-column>
                        <el-table-column label="序号" align="center" width="60">
                            <template slot-scope="scope">
                                <div>{{ (page - 1) * pageSize + scope.$index + 1 }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="预览" align="center" prop="paths" width="80px">
                            <template slot-scope="scope">
                                <div style="line-height: 1">
                                    <el-image
                                        v-if="dataType === DataTypeEmu.IMAGE"
                                        :src="scope.row.paths"
                                        style="width: 48px; height: 32px"
                                        :preview-src-list="[scope.row.paths]"
                                    ></el-image>
                                    <el-image
                                        v-else-if="dataType === DataTypeEmu.VIDEO"
                                        @click="playVideo(scope.row)"
                                        :src="scope.row.imageUrl"
                                        style="width: 48px; height: 32px; cursor: pointer"
                                    ></el-image>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="名称" align="center" prop="name"></el-table-column>
                        <el-table-column label="任务名称" align="center" prop="taskName"></el-table-column>
                        <el-table-column
                            label="上传时间"
                            align="center"
                            prop="time"
                            width="140px"
                        ></el-table-column>
                    </el-table>
                    <div class="page-container">
                        <div class="page-total">
                            <span>
                                共
                                <span class="primary">{{ pageCount }}</span>
                                页
                            </span>
                            <span class="split">/</span>
                            <span>
                                共
                                <span class="primary">{{ total }} </span>

                                条数据
                            </span>
                            <span class="split">/</span>
                            <span>
                                已选
                                <span class="primary">{{ checkedTableData.length }} </span>

                                条
                            </span>
                        </div>
                        <div style="margin-left: auto">
                            <!--  :page-size.sync="pageSize" -->
                            <el-pagination
                                background
                                layout="prev, pager, next,slot,jumper"
                                :total="total"
                                :page-size="pageSize"
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                            >
                                <el-select
                                    v-model="pageSize"
                                    placeholder="请选择或输入数字"
                                    filterable
                                    allow-create
                                    default-first-option
                                    @change="selectPageChange"
                                >
                                    <el-option
                                        v-for="item in pageSizeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                        <span>{{ item.label }}</span>
                                        <span> 条/页</span>
                                    </el-option>
                                </el-select>
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-btn-group">
                <!-- <el-button @click="preStep">上一步</el-button> -->
                <el-button @click="handleClose">取消</el-button>
                <el-button
                    class="btn-ok"
                    v-if="formData.sourceType !== SourceTypeEmu.COMPUTER"
                    @click="handleOk"
                    type="primary"
                    :disabled="disabled2"
                    >确定</el-button
                >
                <el-button
                    class="btn-ok"
                    v-if="formData.sourceType === SourceTypeEmu.COMPUTER"
                    @click="doNext"
                    type="primary"
                    :disabled="disabled2"
                    >确定</el-button
                >
            </div>
        </el-dialog>

        <!-- 视频播放框 -->
        <el-dialog
            custom-class="c-dialog"
            :title="videoDialogTitle"
            :visible.sync="videoDialogVisible"
            width="640px"
            @close="handleVideoDialogClose"
        >
            <video :src="videoSrc" controls style="width: 600px"></video>
        </el-dialog>
    </div>
</template>

<script>
import * as Api from './Api';

const DataTypeEmu = {
    VIDEO: 1,
    IMAGE: 2,
};
const SourceTypeEmu = {
    // 数据类型
    REMOTE: 'remote',
    COMPUTER: 'computer',
    ACHIEVEMENT: 'achievement',
};

export default {
    components: {},
    props: {},
    data() {
        return {
            loading: false,
            DataTypeEmu,
            SourceTypeEmu,
            disabled: false, // 防止重复点击
            disabled2: false, // 防止重复点击
            step: 1,
            dialogVisible: true,
            searchForm: { name: '', timeStart: '', timeEnd: '', taskName: '' },
            formData: {
                code: '',
                name: '',
                dataType: DataTypeEmu.IMAGE, // 数据类型,1:视频2：照片
                sourceType: SourceTypeEmu.REMOTE, // 导入方式
                fileList: [],
                dataList: '',
                dataPath: '',
            },
            rules: {
                name: [{ required: true, message: '必填项不能为空!', trigger: 'blur' }],
                fileList: [{ required: true, message: '必填项不能为空!', trigger: 'blur' }],
            },
            tableData: [],
            page: 1,
            pageSize: 10,
            total: 0,
            checkedTableData: [], // 已选择的表格数据
            checkedTableData2: [],
            videoDialogVisible: false,
            videoSrc: '',
            videoDialogTitle: '',
            placeholderTaskName:'请输入任务名称',
            pageSizeList: [
                {
                    value: 10,
                    label: 10,
                },
                {
                    value: 30,
                    label: 30,
                },
                {
                    value: 50,
                    label: 50,
                },
                {
                    value: 100,
                    label: 100,
                },
            ],
        };
    },
    watch: {
        pageSize: {
            handler(newVal) {
                this.getRawDataTotal();
                this.getRawDataList();
            },
            deep: true,
        },
        searchForm: {
            handler(newVal) {
                this.getRawDataTotal();
                this.getRawDataList();
            },
            deep: true,
            // immediate:true
        },
        sourceType: {
            handler(val) {
                // 默认原始数据
                if (val === 'remote' || val === 'achievement') {
                    this.getRawDataTotal();
                    this.getRawDataList();
                } else {
                    this.doUpload().then((res) => {
                        // console.log(res);
                        // let uploadRes = res || [];
                        // let dataPath = uploadRes.join();
                        // this.formData.dataPath = dataPath;
                        // // 保存
                        // this.handleOk();
                    });
                }
            },
            deep: true,
        },
    },
    computed: {
        dialogTitle() {
            let title = '添加标注任务';
            let step = this.step;
            let dataType = this.formData.dataType;

            if (step === 2) {
                if (dataType === DataTypeEmu.VIDEO) {
                    // 视频
                    title = '添加视频';
                } else if (dataType === DataTypeEmu.IMAGE) {
                    // 照片
                    title = '添加照片';
                }
            }
            return title;
        },
        labelName() {
            return `${this.dataType === DataTypeEmu.VIDEO ? '视频' : '照片'}名称`;
        },
        dataType() {
            return this.formData.dataType;
        },
        sourceType() {
            return this.formData.sourceType;
        },
        tip() {
            let text = '请填写标注任务信息';
            let step = this.step;
            let dataType = this.formData.dataType;
            if (step === 2) {
                if (dataType === DataTypeEmu.VIDEO) {
                    // 视频
                    text = '请选择需要标注的视频';
                } else if (dataType === DataTypeEmu.IMAGE) {
                    // 照片
                    text = '请选择需要标注的照片';
                }
            }
            return text;
        },
        accept() {
            let accept = 'image/*';
            let dataType = this.formData.dataType;
            if (dataType === 1) {
                accept = 'video/*';
            } else if (dataType === 2) {
                accept = 'image/*';
            }
            return accept;
        },
        pageCount() {
            let count = 0;
            let total = this.total;
            let pageSize = Number(this.pageSize);
            if (total % pageSize === 0) {
                count = total / Number(pageSize);
            } else {
                count = Math.ceil(total / Number(pageSize));
            }
            return count;
        },
    },
    methods: {
        handleClose() {
            this.closeWindow();
        },
        closeWindow() {
            /* eslint-disable */
            if (confirm('您确定要关闭本页吗？') === true) {
                let userAgent = navigator.userAgent;
                if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
                    // window.location.replace('about:blank');
                    let opened = window.open('about:blank', '_self');
                    // opened.opener = null;
                    opened.close();
                } else {
                    window.opener = null;
                    window.open('', '_self');
                }
                window.close();
            }
        },
        handleUpload(req) {
            // console.log(req);
            let self = this;
            let file = req.file;
            let type = file.type;
            // console.log(req);
            this.formData.fileList.push(file);
        },
        beforeUpload(file) {
            let type = file.type;
            const valid = this.validFileType(type);

            if (!valid) {
                let message = '请上传正确的文件类型';

                if (this.formData.dataType === DataTypeEmu.IMAGE) {
                    message = '请选择照片';
                } else if (this.formData.dataType === DataTypeEmu.VIDEO) {
                    message = '请选择视频';
                }
                this.$message({
                    type: 'error',
                    message,
                });
            }
            return valid;
        },
        /**
         * 校验文件格式
         */
        validFileType(type) {
            let pattern = /^image\/[a-zA-Z]{3,}/gi;
            let accept = this.accept;
            if (accept) {
                if (accept.indexOf('image') !== -1) {
                    pattern = /^image\/[a-zA-Z]{3,}/gi;
                } else if (accept.indexOf('video') !== -1) {
                    pattern = /^video\/[a-zA-Z0-9]{3,}/gi;
                }
            }
            return pattern.test(type);
        },
        handleRemove(file, fileList) {
            const uid = file.uid;
            this.formData.fileList = this.formData.fileList.filter((item) => item.uid !== uid);
        },
        /**
         * 下一步
         */
        doNext() {
            if (this.disabled) return;
            let sourceType = this.formData.sourceType;
            if (this.formData.dataType === DataTypeEmu.VIDEO) {
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (sourceType === SourceTypeEmu.COMPUTER) {
                        this.disabled = true;
                        // 本地导入
                        this.doUpload().then((res) => {
                            console.log(res);
                            let uploadRes = res || [];
                            let dataPath = uploadRes.join();
                            this.formData.dataPath = dataPath;
                            // 保存
                            this.handleOk();
                        });
                    }
                    // else if (
                    //     sourceType === SourceTypeEmu.REMOTE ||
                    //     sourceType === SourceTypeEmu.ACHIEVEMENT
                    // ) {
                    //     // 原始数据导入
                    //     this.step = 2;
                    //     this.getRawDataTotal();
                    //     this.getRawDataList();
                    // }
                }
            });
        },
        async doUpload() {
            let fileList = this.formData.fileList;
            let uploadPromiseList = [];
            fileList.forEach((file) => {
                let pFormData = new FormData();
                pFormData.append('file', file);
                let uploadPromise = Api.uploadFile(pFormData).run();
                uploadPromiseList.push(uploadPromise);
            });
            return new Promise((resolve) => {
                Promise.all(uploadPromiseList).then((res) => {
                    resolve(res);
                });
            });
        },
        /**
         * 上一步
         */
        preStep() {
            this.step -= 1;
        },
        selectPageChange(val) {
            this.pageSize = Number(val);
            this.getRawDataList(1);
        },
        /**
         * 获取原始数据列表
         */
        getRawDataList(page) {
            let currentPage = page || this.page;
            let param = {
                page: currentPage,
                rows: Number(this.pageSize),
                dataType: this.formData.dataType,
                getType: this.sourceType === 'remote' ? 1 : 2,
                ...this.searchForm,
            };
            let list = [];
            Api.fetchRawDataList(param)
                .run()
                .then((res) => {
                    list = res || [];
                    this.tableData = list;
                });
        },

        /**
         * 获取原始数据总数
         */
        getRawDataTotal(page) {
            let currentPage = page || this.page;
            let param = {
                page: currentPage,
                rows: Number(this.pageSize),
                dataType: this.formData.dataType,
                getType: this.sourceType === 'remote' ? 1 : 2,
                ...this.searchForm,
            };
            let total = 0;
            Api.fetchRawDataTotal(param)
                .run()
                .then((res) => {
                    total = res || 0;
                    this.total = total;
                });
        },

        /**
         * 页码改变
         */
        handleCurrentChange(page) {
            this.page = page;
            this.getRawDataList(page);
        },

        /**
         * 页大小改变
         */
        handleSizeChange(size) {
            this.pageSize = Number(size);
            this.getRawDataList(1);
        },

        /**
         * 选择表格数据
         */
        handleSelectionChange(val) {
            console.log('handleSelectionChange', val);
            this.checkedTableData = val;
        },
        /**
         * 保存
         */
        handleOk() {
            console.log(111);
            if (this.disabled2) return;
            let sourceType = this.formData.sourceType;
            if (sourceType === SourceTypeEmu.REMOTE || sourceType === SourceTypeEmu.ACHIEVEMENT) {
                if (this.checkedTableData.length <= 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择数据！',
                        type: 'warning',
                    });
                    return;
                }
                let dataList = [];
                let checkedTableData = this.checkedTableData;
                checkedTableData.forEach((item) => {
                    dataList.push(item.id);
                });
                this.formData.dataList = dataList.join();
            }
            const { code, name, dataList, dataType, dataPath } = this.formData;
            let param = {
                code,
                name,
                dataList,
                dataType,
                dataPath,
            };

            this.disabled2 = true;

            Api.fetchSaveTask(param)
                .run()
                .then((res) => {
                    // this.$router.push('/annotator/annotate');
                    if (res) {
                        const id = res.id;
                        this.$router.push({ path: `/annotator/annotate/${id}` });
                    }
                    this.loading = true;
                    setTimeout(() => {
                        this.disabled = false;
                        this.disabled2 = false;
                        this.dialogVisible = false;
                    }, 6000);
                });
        },
        reset() {
            Object.keys(this.searchForm).map((key) => {
                this.searchForm[key] = '';
            });
            this.doSearch();
        },
        doSearch() {
            this.page = 1;
            this.getRawDataTotal(this.page);
            this.getRawDataList(this.page);
        },
        handleDatePickerChange(val) {
            console.log(val);
            if (val) {
                this.searchForm.timeStart = `${val} 00:00:00`;
                this.searchForm.timeEnd = `${val} 23:59:59`;
            } else {
                this.searchForm.timeStart = '';
                this.searchForm.timeEnd = '';
            }
        },
        //播放视频
        playVideo(data) {
            console.log(data);
            this.videoSrc = data.paths;
            this.videoDialogTitle = data.name;
            this.videoDialogVisible = true;
        },
        handleVideoDialogClose() {
            this.videoSrc = '';
            this.videoDialogTitle = '';
            this.videoDialogVisible = false;
        },
    },
    created() {},
    mounted() {
        // this.getRawDataTotal();
        // this.getRawDataList();
        let taskName = this.$route.query.taskName
        if(taskName){
            this.searchForm.taskName =  taskName;
            this.formData.name = taskName;
            this.formData.sourceType = 'achievement';
            this.searchForm.sourceType = 'achievement';
        }
        console.log('formData',this.formData);
    },
};
</script>

<style lang="scss" scoped>
$btnColor-disabled: #95a3b9;
::v-deep .c-dialog {
    position: relative;
    margin: 0 auto 50px;
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
    box-sizing: border-box;
    border: none;
    .el-dialog {
        &__header {
            background-color: #f7f8fa !important;
            padding: 16px 20px;
            border: none !important;
            box-shadow: none !important;
        }
        &__title {
            line-height: 24px;
            font-size: 18px;
            color: #303133;
        }
        &__body {
            padding: 24px 20px;
            .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
                background: #f7f8fa;
            }
            .el-table--mini {
                .el-table__body {
                    .el-table__cell {
                        padding: 2px 0px;
                    }
                }
            }
            .el-image__error {
                font-size: 12px !important;
            }
        }
    }
}
.h-tip {
    color: #000;
    font-size: 16px;
    padding: 10px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
}
.dialog-main {
    // min-height: 360px;
}
.form-container {
    display: flex;
    // justify-content: center;
    box-sizing: border-box;
}
.next-container {
    .el-button {
        // color: #fff;
        &:hover {
            // border-color: $btnColor;
        }
    }
}
.page-container {
    display: flex;
    box-sizing: border-box;

    margin-top: 16px;
    margin-bottom: 16px;
    .page-total {
        display: inline-block;
        font-size: 13px;
        min-width: 35.5px;
        height: 32px;
        line-height: 32px;
        vertical-align: top;
        box-sizing: border-box;
    }
    .primary {
        color: #2e7df8;
    }
    .split {
        padding: 0 4px;
    }
    ::v-deep .el-pagination__jump {
        margin-left: 0px !important;
    }
}
.footer-btn-group {
    text-align: center;
    .btn-ok {
        // background-color: $btnColor;
        // color: #fff;
        &:hover {
            // border-color: $btnColor;
        }
    }
}
</style>
